export const configQueryReactSimpleRequestSecurity = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    keepPreviousData: false,
    retry: 1,
};
export const SECURITY_MODULE_ID = 1;
